import { isolatedHeader, type IsolatedKey } from 'Addons/fitmentSearch/isolatedKeys';

const isolatedKey: IsolatedKey = isolatedHeader;

export default isolatedKey;
